import { TransitPolicy, TransitPolicyRule } from '../models/TransitPolicy';

const isRecord = (value: unknown): value is Record<string, any> =>
    typeof value === 'object' && value !== null && !Array.isArray(value);

/**
 * Wrap gateway/editor JSON in the model classes, so rules keep their
 * constructor behaviour (identity-stable keys in the editor, JSON round trips).
 */
export const normalizeTransitPolicy = (policy: unknown): TransitPolicy | undefined => {
    if (!isRecord(policy)) {
        return undefined;
    }

    const normalizedPolicy = new TransitPolicy(policy);
    const rawRules = Array.isArray(policy.rules) ? policy.rules : [];
    normalizedPolicy.rules = rawRules.map((rule) =>
        rule instanceof TransitPolicyRule ? rule : new TransitPolicyRule(isRecord(rule) ? rule : {})
    );

    return normalizedPolicy;
};
